import { render, staticRenderFns } from "./clientspart.vue?vue&type=template&id=2d8212fe&"
import script from "./clientspart.vue?vue&type=script&lang=js&"
export * from "./clientspart.vue?vue&type=script&lang=js&"
import style0 from "./clientspart.vue?vue&type=style&index=0&id=2d8212fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports